module.exports = __webpack_public_path__ + "static/media/profile-wishlist-icon.fa60101f.svg";